export const handleError = (error) => {
  console.error('Error:', error);
  
  if (error.response) {
    return error.response.data.message || 'An error occurred while processing your request';
  }
  
  if (error.message) {
    return error.message;
  }
  
  return 'An unexpected error occurred';
}; 